module.exports = __webpack_public_path__ + "static/media/next.3216da0d.svg";